import { ErrorHandler, inject } from '@angular/core';
import { MaintenanceService } from '@app/core/maintenance/maintenance.service';
import { HttpStatusCode } from '@angular/common/http';

export class MaintenanceErrorHandler implements ErrorHandler {
  private maintenanceService = inject(MaintenanceService);

  handleError(error: any) {
    if (
      error.status > HttpStatusCode.InternalServerError ||
      error.status === 0
    ) {
      this.maintenanceService.navigateServiceUnavailable();
    }
  }
}
